import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { deleteLead, getLeads } from "../../../api/lead";
import { usePagination } from "../../../hooks/usePagination";
import PaginationHandler from "../../../components/PaginationHandler";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { Button } from "reactstrap";
import { useNavigate } from "react-router-dom";

export default function LeadsList() {
    const navigate = useNavigate();
    console.log("1111111111111111111", localStorage.getItem("currentUser"));
    const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
    const role = currentUser.role || currentUser.roleName || {};

    const hasPermission = (action) => {
        if (role.name === "super admin") return true;
        return (
            role.permissions &&
            role.permissions.some(
                (perm) => perm.resource === "Monitor" && perm.actions.includes(action)
            )
        );
    };

    const canCreate = () => hasPermission("create");
    const canEdit = () => hasPermission("update");
    const canDelete = () => hasPermission("delete");
    const canRead = () => hasPermission("update") || hasPermission("delete");

    useEffect(() => {
        console.log("Current User:", currentUser);
        console.log("Role:", role.name);
        console.log("Permissions:", role.permissions);
        console.log("canCreate:", canCreate());
        console.log("canEdit:", canEdit());
        console.log("canDelete:", canDelete());
        console.log("canRead:", canRead());
    }, [currentUser]);

    const {
        response,
        loading,
        error,
        setPage,
        page,
        setMeta,
        totalPages,
    } = usePagination(getLeads, null, true);

    console.log("getLeadsgetLeadsgetLeads", getLeads);
    const [filters, setFilters] = useState({
        name: "",
        email: "",
        phone: "",
    });

    function handleFilter() {
        setMeta((m) => ({
            ...m,
            page: 1,
            payload: {
                ...filters,
            },
        }));
    }

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this lead?")) {
            try {
                await deleteLead(id);
                setPage(1);
            } catch (error) {
                console.error("Delete failed:", error);
                alert("Failed to delete lead.");
            }
        }
    };
    console.log("11111111111111", response);
    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs
                    title={"Leads"}
                    addUrl={canCreate() ? "/leads/add" : null}
                    hasAddBtn={canCreate()}
                    isMainPage={true}
                />

                {canRead() || canEdit() || canDelete() ? (
                    response && response.length > 0 && !loading ? (
                        <CustomTable
                            emptyMsg={"No Leads Found."}
                            data={response}
                            loading={loading}
                            error={error}
                            cols={[
                                {
                                    label: "Name",
                                    key: "name",
                                    style: { width: "10%" },
                                },
                                {
                                    label: "Email",
                                    key: "email",
                                    style: { width: "30%" },
                                },
                                {
                                    label: "Phone",
                                    key: "phone",
                                    style: { width: "16%" },
                                },
                                {
                                    label: "Assigned To",
                                    key: "assignedTo",
                                    style: { width: "15%" },
                                    renderer: (row) => <>{row.assignedTo?.name}</>,
                                },
                                {
                                    label: "Lead Source",
                                    key: "leadSource",
                                    style: { width: "15%" },
                                    renderer: (row) => <>{row.leadSource?.name}</>,
                                },
                                {
                                    label: "Actions",
                                    key: "actions",
                                    style: { width: "14%" },
                                    renderer: (row) => (
                                        <div className="d-flex gap-2">
                                            {canRead() && (
                                                <Button
                                                    color="secondary"
                                                    size="sm"
                                                    onClick={() => navigate(`/leads/show/${row._id}`)}
                                                >
                                                    Show
                                                </Button>
                                            )}
                                            {canEdit() && (
                                                <Button
                                                    color="info"
                                                    size="sm"
                                                    onClick={() => navigate(`/leads/edit/${row._id}`)}
                                                >
                                                    Edit
                                                </Button>
                                            )}
                                            {canDelete() && (
                                                <Button
                                                    color="danger"
                                                    size="sm"
                                                    onClick={() => handleDelete(row._id)}
                                                >
                                                    Delete
                                                </Button>
                                            )}

                                        </div>
                                    ),
                                },
                            ]}
                        />
                    ) : (
                        !loading && <div>No results found.</div>
                    )
                ) : (
                    <div>You do not have permission to view this list.</div>
                )}

                {response && !loading && canRead() && (
                    <PaginationHandler
                        page={page}
                        setPage={setPage}
                        totalPages={totalPages}
                    />
                )}
            </div>
        </div>
    );
}
